import { useState } from "react";
import { downloadOptions } from "@/mocks/home";
import SectionHeading from "@/components/feature/SectionHeading";

export default function DownloadSection() {
  const [activeId, setActiveId] = useState(downloadOptions[0].id);
  const current =
    downloadOptions.find((item) => item.id === activeId) ?? downloadOptions[0];

  return (
    <section id="download" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4">
        <SectionHeading
          eyebrow="APP 客户端下载"
          title="装一个客户端，地址变动不再麻烦"
          desc="客户端内置线路自动切换，地址更新时无需手动更换，稳定性也更高。下面按设备选择对应的下载方式即可。"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <div className="mb-4 flex flex-wrap gap-1 rounded-full bg-background-50 p-1">
              {downloadOptions.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => setActiveId(item.id)}
                  className={
                    activeId === item.id
                      ? "flex cursor-pointer items-center gap-1.5 rounded-full bg-primary-500 px-3.5 py-1.5 text-sm font-medium text-background-50"
                      : "flex cursor-pointer items-center gap-1.5 rounded-full px-3.5 py-1.5 text-sm font-medium text-foreground-600 transition-colors hover:text-foreground-900"
                  }
                >
                  <i className={item.icon}></i>
                  {item.platform}
                </button>
              ))}
            </div>

            <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <div className="flex flex-wrap items-center justify-between gap-3">
                <div className="flex items-center gap-3">
                  <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${current.icon} text-2xl`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-lg font-bold text-foreground-950">
                      {current.platform} 客户端
                    </h3>
                    <p className="text-xs text-foreground-500">
                      {current.requirement} · 安装包 {current.size}
                    </p>
                  </div>
                </div>
                <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                  <i className="ri-shield-check-line"></i>
                  官方渠道
                </span>
              </div>

              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                {current.highlight}
              </p>

              <ol className="mt-4 flex flex-col gap-3">
                {current.steps.map((step, index) => (
                  <li key={step} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-500 text-xs font-medium text-background-50">
                      {index + 1}
                    </span>
                    <span className="text-sm leading-relaxed text-foreground-700">
                      {step}
                    </span>
                  </li>
                ))}
              </ol>

              <a
                href="#entry"
                className="mt-5 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-download-2-line"></i>
                前往下载入口
              </a>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="h-full overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="h-56 w-full md:h-64">
                <img
                  src="https://readdy.ai/api/search-image?query=laptop%20smartphone%20and%20tablet%20displaying%20warm%20amber%20movie%20interface%20screens%20on%20cream%20desk%2C%20minimal%20clean%20tech%20still%20life%2C%20soft%20natural%20light%2C%20warm%20neutral%20palette&width=1000&height=750&seq=cinema-device-03&orientation=landscape"
                  alt="星辰影院手机、平板与电脑客户端界面示意"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  为什么推荐使用客户端
                </h3>
                <ul className="mt-3 flex flex-col gap-2.5 text-sm text-foreground-600">
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line mt-0.5 text-primary-600"></i>
                    内置多条线路，自动挑选更稳定的通路
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line mt-0.5 text-primary-600"></i>
                    域名变动时自动同步，无需手动换地址
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line mt-0.5 text-primary-600"></i>
                    支持倍速、投屏与省流播放，观看更灵活
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line mt-0.5 text-primary-600"></i>
                    登录后可同步收藏与观看进度
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}